/**
 * Zzzing Admin API
 * Zzzing Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RightOfUsePeriodRule } from './rightOfUsePeriodRule';


export interface ContractRightOfUse { 
    /**
     * The total number of days that the owner is allowed to use the property for a year.
     */
    maximum_allowed_days?: number;
    /**
     * The total number of days that the owner used the property for the current year.
     */
    total_days_used?: number;
    period_rules?: Array<RightOfUsePeriodRule>;
}

